import React from 'react';

type Props = {
  label: string;
  score: number; // 0..100
  hint?: string;
};

export function ScoreRing({ label, score, hint }: Props) {
  const size = 96;
  const stroke = 10;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(100, score));
  const dash = (pct / 100) * c;

  return (
    <div className="lbf-card p-4">
      <div className="flex items-center justify-between">
        <div>
          <div className="text-sm font-extrabold text-white">{label}</div>
          {hint ? <div className="mt-1 text-xs text-zinc-300/80">{hint}</div> : null}
        </div>
        <div className="grid place-items-center">
          <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-label={`${label}: ${pct}/100`}>
            <defs>
              <linearGradient id="lbfRing" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="rgb(236,72,153)" stopOpacity="1" />
                <stop offset="100%" stopColor="rgb(99,102,241)" stopOpacity="1" />
              </linearGradient>
            </defs>
            <circle
              cx={size / 2}
              cy={size / 2}
              r={r}
              fill="none"
              stroke="rgba(255,255,255,.10)"
              strokeWidth={stroke}
            />
            <circle
              cx={size / 2}
              cy={size / 2}
              r={r}
              fill="none"
              stroke="url(#lbfRing)"
              strokeWidth={stroke}
              strokeLinecap="round"
              strokeDasharray={`${dash} ${c - dash}`}
              transform={`rotate(-90 ${size / 2} ${size / 2})`}
            />
            <text
              x="50%"
              y="52%"
              textAnchor="middle"
              dominantBaseline="middle"
              fill="white"
              fontSize="20"
              fontWeight="800"
            >
              {pct}
            </text>
          </svg>
        </div>
      </div>
    </div>
  );
}


